import React, { createContext, useContext, ReactNode } from 'react';
import {
  useRepositoryScanProgress,
  RepositoryScanProgress,
} from '../hooks/useRepositoryScanProgress';

const DEFAULT_VALUE: RepositoryScanProgress = {
  state: null,
  batchId: null,
  scanTypeLabel: '',
  percent: 0,
  findingsCount: 0,
  currentOperation: '',
  applicationId: null,
  dismiss: () => {},
};

const ScanProgressContext = createContext<RepositoryScanProgress | null>(null);

/**
 * Provides a single repository-wide scan-progress poller for the whole app shell, so
 * the progress banner and the sidebar "scan running" indicator share one source of
 * truth (and one polling loop) instead of each running their own.
 */
export const ScanProgressProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const value = useRepositoryScanProgress();
  return <ScanProgressContext.Provider value={value}>{children}</ScanProgressContext.Provider>;
};

/** Read repository-wide scan progress. Returns an inert default outside the provider. */
export const useScanProgress = (): RepositoryScanProgress => {
  return useContext(ScanProgressContext) ?? DEFAULT_VALUE;
};

export default ScanProgressContext;
